// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"1c9020af","453":"300d14d4","520":"4e6ee2b0","803":"6774ebbe","939":"f7e75c04"}[chunkId] + ".chunk.js";
};